var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup430(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H53V54H0z",
    transform: "translate(-.164 .082) translate(.164 -.082)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#61805b",
    d: "M21.965 9.414V3.788a1.57 1.57 0 0 0-.459-1.11L19.287.459A1.569 1.569 0 0 0 18.177 0H4.707a1.569 1.569 0 0 0-1.569 1.569v7.845A3.138 3.138 0 0 0 0 12.552v5.491a.784.784 0 0 0 .784.784h2.354v4.707A1.569 1.569 0 0 0 4.707 25.1H20.4a1.569 1.569 0 0 0 1.569-1.569v-4.704h2.353a.784.784 0 0 0 .784-.784v-5.491a3.138 3.138 0 0 0-3.141-3.138zm-3.138 12.551H6.276v-4.706h12.551zm0-10.983H6.276V3.138h9.414v2.353a.784.784 0 0 0 .784.784h2.353zm2.353 3.53a1.177 1.177 0 1 1 1.177-1.177 1.177 1.177 0 0 1-1.176 1.178z",
    transform: "translate(-.164 .082) translate(14.852 14.879)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup430);
export default __webpack_public_path__ + "static/media/Group 430.c1125552f396b58c6aec755b62781890.svg";
export { ForwardRef as ReactComponent };